import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";
import { Helmet } from "react-helmet";

export default function Container_Transportation() {

  const seo = {
    title:
      "הובלת מכולות | הובלת קונטיינרים | ש.מ הובלות ומנופים",

    description:
      "שירותי הובלת מכולות וקונטיינרים לקבלנים, חברות, עסקים, אתרי בנייה ולקוחות פרטיים. הובלה מקצועית והתאמת פתרון השינוע לתנאי השטח, למידות ולמשקל המכולה.",

    url:
      "https://smtovala.co.il/Container_Transportation",

    image:
      "https://smtovala.co.il/images/33.png"
  };

  return (
    <>
      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      <div className="Transportation_of_building_materials-page">

        <div className="Transportation_of_building_materials-hero">

          <div className="Transportation_of_building_materials-overlay">

            <h1>הובלת מכולות</h1>

          </div>

        </div>


        {/* =====================================================
            CONTENT
        ===================================================== */}

        <div className="page3">

          <div className="container">


            {/* =====================================================
                VIDEO - ראשון
            ===================================================== */}

            <div className="building-video-box">

              <div className="building-video-title">
                הובלת מכולות
              </div>





            </div>


            {/* =====================================================
                TOP TEXT
            ===================================================== */}

            <h2 className="top-text">

              צריכים להעביר מכולה ממקום למקום? ש.מ הובלות ומנופים
              מספקת שירותי הובלת מכולות עבור קבלנים, חברות, עסקים,
              אתרי בנייה ולקוחות פרטיים. אנו מתאימים את פתרון ההובלה
              לסוג המכולה, למידותיה, למשקל ולתנאי הגישה במקום.

            </h2>


            {/* =====================================================
                IMAGE + TEXT
            ===================================================== */}

            <div className="content-row">

              <div className="image-box">

                <img
                  src="/images/33.png"
                  alt="הובלת מכולות"
                />

              </div>


              <div className="text-box">

                <p>

                  הובלת מכולה דורשת בדיקה מוקדמת של הדרך ושל נקודות
                  האיסוף והפריקה. חשוב לקחת בחשבון את גודל המכולה,
                  המשקל שלה, תנאי הכניסה למקום והאופן שבו ניתן למקם
                  אותה ביעד.

                </p>


                <p>

                  ש.מ הובלות ומנופים נותנת מענה למגוון צרכים בתחום
                  הובלת המכולות, החל מהעברת מכולות אחסון וציוד ועד
                  הובלה לאתרי בנייה ולעסקים, בהתאם לתנאים הקיימים
                  בשטח ולדרישות הלקוח.

                </p>

              </div>

            </div>


            {/* =====================================================
                SECTION 1
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכולות בהתאמה לתנאי השטח
            </h2>


            <div className="bottom-text">

              <p>

                לפני שמתחילים בהובלת מכולה חשוב לבדוק את מסלול הנסיעה,
                את נקודת האיסוף ואת המקום שבו המכולה אמורה להיות מוצבת.
                בדיקה מוקדמת יכולה לסייע בבחירת אמצעי ההובלה המתאים
                ובתכנון העבודה.

              </p>


              <p>

                כאשר מדובר במקומות בעלי גישה מוגבלת, חניות צפופות,
                רחובות צרים או אתרי בנייה מורכבים, יש חשיבות מיוחדת
                לתכנון ההגעה והפריקה מראש.

              </p>


              {/* =====================================================
                  SECTION 2
              ===================================================== */}

              <h2 className="main-title">
                הובלת מכולות עם משאית מתאימה
              </h2>


              <p>

                מכולות מגיעות בגדלים ובמשקלים שונים ולכן חשוב להתאים
                את אמצעי ההובלה למטען. בחירת המשאית מתבצעת בהתאם
                למידות המכולה, למשקל ולתנאי הדרך.

              </p>


              <p>

                תכנון נכון של ההובלה מאפשר להגיע לנקודת היעד ולבצע
                את הפריקה בצורה מסודרת, בהתאם למיקום שבו המכולה
                צריכה להיות מוצבת.

              </p>


              {/* =====================================================
                  SECTION 3
              ===================================================== */}

              <h2 className="main-title">
                הובלת מכולות לאתרי בנייה
              </h2>


              <p>

                באתרי בנייה מכולות יכולות לשמש לאחסון כלי עבודה,
                ציוד, חומרים ופריטים שונים לאורך הפרויקט. העברת
                המכולה לאתר דורשת התייחסות למיקום ההצבה ולתנאי
                הכניסה לשטח.

              </p>


              <p>

                ש.מ הובלות ומנופים מספקת שירותי הובלת מכולות
                לאתרי בנייה ולפרויקטים שונים, בהתאם למיקום,
                לסוג המכולה ולתנאי העבודה במקום.

              </p>


              {/* =====================================================
                  SECTION 4
              ===================================================== */}

              <h2 className="main-title">
                הובלת מכולה והצבה באמצעות מנוף
              </h2>


              <p>

                במקרים שבהם יש צורך להציב את המכולה במקום שאינו
                צמוד לנקודת העצירה של המשאית, ניתן לבחון שילוב
                של מנוף לצורך הרמה והצבה בהתאם לתנאי האתר.

              </p>


              <p>

                פתרון משולב של הובלה ומנוף יכול להתאים לחצרות,
                אתרי בנייה, שטחים פרטיים ומקומות שבהם תנאי הגישה
                אינם מאפשרים הצבה רגילה של המכולה.

              </p>


              {/* =====================================================
                  SECTION 5
              ===================================================== */}

              <h2 className="main-title">
                הובלת מכולות אחסון וציוד
              </h2>


              <p>

                מכולות משמשות כיום עסקים, קבלנים, אתרי בנייה
                ולקוחות פרטיים למטרות שונות, ובהן אחסון ציוד,
                אחסון חומרים, מחסנים זמניים ושימושים נוספים.

              </p>


              <p>

                כאשר נדרשת העברת מכולה, חשוב לבדוק את מצבה,
                מידותיה, המשקל ותנאי הגישה אל המקום שבו היא
                מיועדת להיות מוצבת.

              </p>


              {/* =====================================================
                  SECTION 6
              ===================================================== */}

              <h2 className="main-title">
                מה חשוב לבדוק לפני הובלת מכולה?
              </h2>


              <p>

                תיאום נכון לפני ההובלה יכול לחסוך עיכובים ולהקל
                על ביצוע העבודה. חשוב למסור מראש את מידות המכולה,
                משקלה המשוער, כתובת האיסוף והיעד ולציין מגבלות
                גישה אם קיימות.

              </p>


              <p>

                ש.מ הובלות ומנופים בוחנת את פרטי ההובלה ומתאימה
                את פתרון העבודה בהתאם למאפייני המכולה, לתנאי הדרך
                ולמיקום שבו נדרשת הפריקה או ההצבה.

              </p>


              {/* =====================================================
                  SECTION 7
              ===================================================== */}

              <h2 className="main-title">
                ש.מ הובלות ומנופים – שירותי הובלת מכולות
              </h2>


              <p>

                ש.מ הובלות ומנופים מספקת שירותי הובלת מכולות
                לקבלנים, חברות, עסקים, אתרי בנייה ולקוחות פרטיים.
                אנו מסייעים בהעברת מכולות בהתאם לסוג המכולה,
                למידותיה ולתנאים הקיימים בנקודת האיסוף והיעד.

              </p>


              <p>

                צריכים להעביר מכולה? התקשרו אל ש.מ הובלות ומנופים,
                מסרו לנו את פרטי ההובלה ונבחן יחד את הדרך המתאימה
                לביצוע העבודה.

              </p>

            </div>


            {/* =====================================================
                CONTACT
            ===================================================== */}

            <ContactSection2 />


            {/* =====================================================
                LINKS
            ===================================================== */}

            <div className="links">

              <Link
                to="/Transporting_heavy_equipment"
                className="link-right"
              >
                הובלת ציוד כבד
              </Link>


              <Link
                to="/Transportation_of_industrial_and_heavy_generators"
                className="link-left"
              >
                הובלת גנרטורים תעשייתיים
              </Link>

            </div>


          </div>

        </div>

      </div>

    </>
  );
}
